<template>
    <div class="control-block marker-legend-block">
      <dl>
        <div v-if="Object.keys(this.sharedState.markerLegends).length !== 0">
        <dt class="is-top">
          <span><img class="icon-pin" src="../../assets/img/marker-all.png"></span>
          <span class="pin-name">
            <input type="checkbox" id="pin-00" 
              :checked="checkedAllFlag" 
              v-model="checkedAllFlag"
              @click="checkAll">
            <label for="pin-00">すべて選択</label>
          </span>
        </dt>
        <div v-for="legend in sharedState.markerLegends" :key="legend.name">
          <dt class="is-accordion">
            <span class="icon-pin"><img class="icon-pin" :src="imgSrc(legend.icon.url)"></span>
            <input type="checkbox"
              :checked="legend.markerShowFlag"
              v-model="legend.markerShowFlag"
              @click="checkLegend(legend, legend.markerShowFlag)">
            <span class="pin-name">{{legend.label}}</span>
            <div v-if="legend.showFlag">
              <span class="pin-flag" @click="toggleShow(legend.label)">-</span>
            </div>
            <div v-else>
              <span class="pin-flag" @click="toggleShow(legend.label)">+</span>
            </div>
          </dt>
          <transition name="slide" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:before-leave="beforeLeave" v-on:leave="leave">
            <dd v-if="legend.showFlag" :key="legend.label">
              <ul>
                <li v-for="item of legend.items" :key="item.label">
                  <label>
                    <input type="checkbox" 
                      v-bind:checked="item.markerShowFlag" 
                      v-model="item.markerShowFlag" 
                      @click="checkOne(item.category, item.markerShowFlag)">
                    {{item.label}}
                  </label>
                </li>
              </ul>
            </dd>
          </transition>
        </div>
        </div>
      </dl>
    </div>
</template>

<script>
  
import axios from 'axios' 
// 静的な require() は ESM のモジュールから呼ぶと { default } が返るため、import で受け取る
import markerAllUrl from '../../assets/img/marker-all.png'

export default {
    name: 'marker-control',
    components:{

    },
    data () {
      return {
        checkedAllFlag: null
      }
    },
    created () {
      this.initCheckedAllFlag()
    },
    mounted () {
      Promise.all([this.$store.dispatch("fetchConfig")])
      // .then(()=>{
      //   this.getMarkerLegends()
      // })
    },
    computed: {
      sharedState () {
        return this.$store.state
      },
      env () {
        return this.sharedState.config_from_api
      }
    },
    watch: {
      env: function() {
        // this.getMarkerLegends()
        // .then(() => {
        // })
      }
    },
    methods: {
      initCheckedAllFlag () {
        let browser = this.sharedState.browser
        if (browser == 'ie' || browser == 'edge') {
          this.checkedAllFlag = true
        } else {
          this.checkedAllFlag = false
        }
      },
      reverseFlag (flag) {
        return !flag
      },
      async getMarkerLegends () {
        const query = this.$route.query
        const APIEndpoint = ('csv' in query) ? this.env.localAPI_markers[query.uid].baseUrl : this.env.localAPI_markers[query.uid].baseUrl;
        const csv = ('csv' in query) ? query.csv : null;
        await axios.get(`${APIEndpoint}/markerLegends`, {
          params: {
            cityCodes: this.sharedState.cityCodes,
            csv: csv
          }
        })
        .then(res => {
          this.$store.commit('setMarkerLegends', res)
        })
        .catch(error => {
          console.log("marker-legends を取得できませんでした．");
        });
      },
      toggleShow: function (label) {
        this.$store.commit('toggleShow', label)
      },
      beforeEnter: function(el) {
        el.style.height = '0';
      },
      enter: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      beforeLeave: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      leave: function(el) {
        el.style.height = '0';
      },
      // 前提：引数のurlにはassetsからの正確なパスが入っている．
      imgSrc (url) {
        if (url) {
          return require(`../../${url}`);
        } else {
          return markerAllUrl;
        }
      },
      checkOne (category, flag) {
        let browser = this.sharedState.browser
        // IEとEdgeはフラグが逆になるので反転
        if ( browser == 'ie' || browser == 'edge' ) flag = !flag
        // 選択したカテゴリのマーカーがなければ return
        if (!(category in this.sharedState.markers)) {
          return;
        }

        // 実行する関数を設定
        let rmOrAdd = '';
        if (flag == true) { // from true to false
          // rmOrAdd = 'removeLayer';
          rmOrAdd = 'displayStyleNone';
        } else { // from false to true
          // rmOrAdd = 'addLayer';
          rmOrAdd = 'displayStyleShow';
        }
        for (const marker of this.sharedState.markers[category]) {
          this.$store.commit(rmOrAdd, marker)
        }
      },
      checkLegend (legend, flag) {
        for(let idx in legend.items) {
          let item = legend.items[idx]
          let browser = this.sharedState.browser
          if ( browser == 'ie' || browser == 'edge' ) {
            item.markerShowFlag = flag
          } else {
            item.markerShowFlag = !flag
          }
          this.checkOne(item.category, flag)
        }
      },
      // 全マーカーの表示/非表示フラグを true か false に書き換える．
      checkAll () {
        const currentFlag = !this.checkedAllFlag; // クリックする前の値が入ってる．
        let browser = this.sharedState.browser
        // 親カテゴリ
        for (const plegend in this.sharedState.markerLegends) {
          this.checkLegend(this.sharedState.markerLegends[plegend], this.checkedAllFlag)
          // 子カテゴリ
          // for (const clegend in this.sharedState.markerLegends[plegend].items) {
          //   const category = this.sharedState.markerLegends[plegend].items[clegend].category;
          //   // console.log(this.checkedAllFlag)
          //   this.checkOne(category, this.checkedAllFlag);
          // }
        }
        if ( browser == 'ie' || browser == 'edge' ) {
          this.$store.commit('modMarkerShowFlags', !currentFlag);
        } else {
          this.$store.commit('modMarkerShowFlags', currentFlag);
        }
      }
    }

}
</script>

<style scoped lang="scss">
.slide-enter-active, .slide-leave-active {
  overflow: hidden;
}
.marker-legend-block {
  dt {
    border-bottom: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    color: #333;
    cursor: pointer;
    display: block;
    font-size: 108%;
    font-weight: bold;
    padding: 5px;
    text-decoration: none;
  }
  .is-accordion {
    position: relative;
  }
  .is-accordion::before {
    background: #808080 none repeat scroll 0 0;
    bottom: 0;
    color: #fff;
    content: "+";
    font-size: 16px;
    font-weight: normal;
    height: 20px;
    line-height: 1;
    margin: auto;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    width: 20px;
  }
  .is-accordion.ac-active::before {
    content: "-";
  }
  .pin-flag {
    background: #808080 none repeat scroll 0 0;
    bottom: 0;
    color: #fff;
    content: "+";
    font-size: 16px;
    font-weight: normal;
    height: 20px;
    line-height: 1;
    margin: auto;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    width: 20px;
  }
  dd {
    margin-left: 0;
    border-bottom: 1px solid #ccc;
    transition: 150ms ease-out;
  }
  ul {
    list-style: none;
    padding-left: 0;
  }
  li {
    vertical-align: middle;
    padding: 0 .5em .5em;
  }
  li:first-child {
    padding-top: .5em;
  }
  li span {
    display: inline-block;
    line-height: 20px;
    vertical-align: middle;
  }
  li .marker-legend-block-icon {
    height: 22px;
    padding: 0 0.5em;
    vertical-align: baseline;
    width: 15px;
  }
  input[type="checkbox"] {
    // display: none;
  }
  label {
    position: relative;
    display: inline-block;
    // padding: 3px 3px 3px 23px;
    padding: 3px 3px 3px 3px;
    cursor: pointer;
  }
  .icon-pin {
    display: inline-block;
    padding: 0 10px 0 0;
    vertical-align: middle;
    width: 16px;
  }
  .icon-pin img {
    max-width: 100%;
  }
  .pin-name {
    font-size: 108%;
    font-weight: bold;
  }
}
</style>
